import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ToLocaleTimeBaseValueConverter {
    toView(value) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            return moment(value).format('LT');
        }
        return value;
    }
}